//*--------------Vistas del administrador -----------------*/
import Editions from '@/pages/admin/editions/Editions.vue'
import showEdition from '@/pages/admin/editions/showEdition.vue'
import editEdition from '@/pages/admin/editions/editEdition.vue'

import nameEdition from '@/pages/admin/editions/resources/nameEdition/nameEdition.vue'
import descriptionEdition from '@/pages/admin/editions/resources/descriptionEdition/descriptionEdition.vue'

import auditoriumsEdition from '@/pages/admin/editions/resources/auditoriums/auditoriumsEdition.vue'
import newAuditoriumEdition from '@/pages/admin/editions/resources/auditoriums/newAuditoriumEdition.vue'
import editAuditoriumEdition from '@/pages/admin/editions/resources/auditoriums/editAuditoriumEdition.vue'
import showAuditoriumEdition from '@/pages/admin/editions/resources/auditoriums/showAuditoriumEdition.vue'
import showAllAuditoriumEdition from '@/pages/admin/editions/resources/auditoriums/showAllAuditoriumEdition.vue'

import programEdition from '@/pages/admin/editions/resources/program/program/programEdition.vue'
import newProgramEdition from '@/pages/admin/editions/resources/program/program/newProgramEdition.vue'
import editProgramEdition from '@/pages/admin/editions/resources/program/program/editProgramEdition.vue'
import showProgramEdition from '@/pages/admin/editions/resources/program/program/showProgramEdition.vue'
import showAllProgramEdition from '@/pages/admin/editions/resources/program/program/showAllProgramEdition.vue'

import activitiesProgramEdition from '@/pages/admin/editions/resources/program/activities/activitiesProgramEdition.vue'
import showActivityProgramEdition from '@/pages/admin/editions/resources/program/activities/showActivityProgramEdition.vue'
import newActivityProgramEdition from '@/pages/admin/editions/resources/program/activities/newActivityProgramEdition.vue'
import editActivityProgramEdition from '@/pages/admin/editions/resources/program/activities/editActivityProgramEdition.vue'
import showAllActivityProgramEdition from '@/pages/admin/editions/resources/program/activities/showAllActivityProgramEdition.vue'

import showActivityEdition from '@/pages/admin/editions/resources/program/showActivityEdition.vue'
import showActivitiesEdition from '@/pages/admin/editions/resources/program/showActivitiesEdition.vue'

import callForEntrepreneursEdition from '@/pages/admin/editions/resources/callForEntrepreneursEdition.vue'
import generalPublicIncomeEdition from '@/pages/admin/editions/resources/generalPublicIncomeEdition.vue'

import typeSponsorsEdition from '@/pages/admin/editions/resources/typeSponsorsEdition.vue'
import sponsorsEdition from '@/pages/admin/editions/resources/sponsors/sponsorsEdition.vue'
import showSponsorsEdition from '@/pages/admin/editions/resources/sponsors/showSponsorsEdition.vue'
import newSponsorEdition from '@/pages/admin/editions/resources/sponsors/newSponsorEdition.vue'
import editSponsorsEdition from '@/pages/admin/editions/resources/sponsors/editSponsorsEdition.vue'
import showSponsorEdition from '@/pages/admin/editions/resources/sponsors/showSponsorEdition.vue'
import showAllSponsorsEdition from '@/pages/admin/editions/resources/sponsors/showAllSponsorsEdition.vue'

import typeFeaturedSponsorsEdition from '@/pages/admin/editions/resources/featuredSponsors/typeFeaturedSponsorsEdition.vue'
import showAllFeaturedSponsorsEdition from '@/pages/admin/editions/resources/featuredSponsors/showAllFeaturedSponsorsEdition.vue'

import featuredSponsorsEdition from '@/pages/admin/editions/resources/featuredSponsors/featuredSponsorsEdition.vue'
import newFeaturedSponsorEdition from '@/pages/admin/editions/resources/featuredSponsors/newFeaturedSponsorEdition.vue'
import editFeaturedSponsorEdition from '@/pages/admin/editions/resources/featuredSponsors/editFeaturedSponsorEdition.vue'
import showFeaturedSponsorEdition from '@/pages/admin/editions/resources/featuredSponsors/showFeaturedSponsorEdition.vue'

import speakersEdition from '@/pages/admin/editions/resources/speakers/speakersEdition.vue'
import showSpeakerEdition from '@/pages/admin/editions/resources/speakers/showSpeakerEdition.vue'
import newSpeakerEdition from '@/pages/admin/editions/resources/speakers/newSpeakerEdition.vue'
import showSpeakersEdition from '@/pages/admin/editions/resources/speakers/showSpeakersEdition.vue'
import editSpeakerEdition from '@/pages/admin/editions/resources/speakers/editSpeakerEdition.vue'

import juriesEdition from '@/pages/admin/editions/resources/jurors/juriesEdition.vue'
import newJuryEdition from '@/pages/admin/editions/resources/jurors/newJuryEdition.vue'
import showJuryEdition from '@/pages/admin/editions/resources/jurors/showJuryEdition.vue'
import editJuryEdition from '@/pages/admin/editions/resources/jurors/editJuryEdition.vue'
import showJuriesEdition from '@/pages/admin/editions/resources/jurors/showJuriesEdition.vue'

import evaluatorsEdition from '@/pages/admin/editions/resources/evaluators/evaluatorsEdition.vue'
import newEvaluatorEdition from '@/pages/admin/editions/resources/evaluators/newEvaluatorEdition.vue'
import showEvaluatorEdition from '@/pages/admin/editions/resources/evaluators/showEvaluatorEdition.vue'
import editEvaluatorEdition from '@/pages/admin/editions/resources/evaluators/editEvaluatorEdition.vue'
import showEvaluatorsEdition from '@/pages/admin/editions/resources/evaluators/showEvaluatorsEdition.vue'

import editionOrganizers from '@/pages/admin/editions/resources/editionOrganizers/editionOrganizers.vue'
import showEditionOrganizers from '@/pages/admin/editions/resources/editionOrganizers/showEditionOrganizers.vue'

import modules from'@/pages/admin/editions/resources/resourcesEorEntrepreneurs/modules/Modules.vue'
import showModule from '@/pages/admin/editions/resources/resourcesEorEntrepreneurs/modules/show.vue'
import showAllModule from '@/pages/admin/editions/resources/resourcesEorEntrepreneurs/modules/showAllModule.vue'
import showPillModule from '@/pages/admin/editions/resources/resourcesEorEntrepreneurs/modules/showPillModule.vue'
import newModule from '@/pages/admin/editions/resources/resourcesEorEntrepreneurs/modules/newModule.vue'
import editModule from '@/pages/admin/editions/resources/resourcesEorEntrepreneurs/modules/editModule.vue'

import pillsModule from'@/pages/admin/editions/resources/resourcesEorEntrepreneurs/pills/pillsModule.vue'
import newPill from'@/pages/admin/editions/resources/resourcesEorEntrepreneurs/pills/newPill.vue'
import showPill from'@/pages/admin/editions/resources/resourcesEorEntrepreneurs/pills/showPill.vue'
import editPill from'@/pages/admin/editions/resources/resourcesEorEntrepreneurs/pills/editPill.vue'

import termsConditionsEdition from '@/pages/admin/editions/resources/termsConditionsEdition.vue'
import aboutJIJEEdition from '@/pages/admin/editions/resources/aboutJIJE/aboutJIJE.vue'
import enableEditStandEdition from '@/pages/admin/editions/resources/enableEditStand/enableEditStand.vue'

import customizationEdition from '@/pages/admin/editions/resources/customization/customizationEdition.vue'
import customizationAppBar from '@/pages/admin/editions/resources/customization/customizationAppBar.vue'
import customizationHome from '@/pages/admin/editions/resources/customization/customizationHome.vue'
import customizationAuditorium from '@/pages/admin/editions/resources/customization/customizationAuditorium.vue'
import customizationProgram from '@/pages/admin/editions/resources/customization/customizationProgram.vue'
import customizationMyProject from '@/pages/admin/editions/resources/customization/customizationMyProject.vue'

import customizationProjectGallery from '@/pages/admin/editions/resources/customization/customizationProjectGallery.vue'

import customizationJuriesCard from '@/pages/admin/editions/resources/customization/customizationJuriesCard.vue'
import customizationSpeakerCard from '@/pages/admin/editions/resources/customization/customizationSpeakerCard.vue'
import customizationEntreprenursAssistentsCard from '@/pages/admin/editions/resources/customization/customizationEntreprenursAssistentsCard.vue'
import customizationAbout from '@/pages/admin/editions/resources/customization/customizationAbout.vue'

import customizationWaitingRoom from '@/pages/admin/editions/resources/customization/customizationWaitingRoom.vue'

import entrepreneurshipsEdition from '@/pages/admin/editions/entrepreneurships/entrepreneurshipsEdition.vue'
import newEntrepreneurshipEdition from '@/pages/admin/editions/entrepreneurships/new/newEntrepreneurshipEdition.vue'
import showConvocationFormEdition from '@/pages/admin/editions/entrepreneurships/show/showConvocationFormEdition.vue'
import showEntrepreneurshipsEdition from '@/pages/admin/editions/entrepreneurships/show/showEntrepreneurshipsEdition.vue'

import customizationLanding from '@/pages/admin/landing/customizationLanding.vue'
import customizationMainSection from '@/pages/admin/landing/resources/customizationMainSection.vue'
import customizationFeaturedSponsorsSection from '@/pages/admin/landing/resources/customizationFeaturedSponsorsSection.vue'
import customizationAuthSection from '@/pages/admin/landing/resources/customizationAuthSection.vue'
import customizationTextSection from '@/pages/admin/landing/resources/customizationTextSection.vue'
import customizationIndicatorsSection from '@/pages/admin/landing/resources/customizationIndicatorsSection.vue'
import customizationFeaturedEntrepreneurshipsSection from '@/pages/admin/landing/resources/customizationFeaturedEntrepreneurshipsSection.vue'
import customizationContactSection from '@/pages/admin/landing/resources/customizationContactSection.vue'

import showConvocationFormAccepted from '@/pages/admin/editions/entrepreneurships/show/entrepreneurship/showConvocationFormAccepted.vue'
import showTeamAccepted from '@/pages/admin/editions/entrepreneurships/show/entrepreneurship/showTeamAccepted.vue'
import showWindowAccepted from '@/pages/admin/editions/entrepreneurships/show/entrepreneurship/showWindowAccepted.vue'

import showModulesPreIncubations from '@/pages/admin/editions/entrepreneurships/show/entrepreneurship/showModulesPreIncubations.vue'
import showModulePreIncubation from '@/pages/admin/editions/entrepreneurships/show/entrepreneurship/showModulePreIncubation.vue'

import EntrepreneurshipsList from '@/pages/admin/entrepreneurships/EntrepreneurshipsListAdmin.vue'
import showEntrepreneurshipListAdmin from '@/pages/admin/entrepreneurships/show/showEntrepreneurshipListAdmin.vue'
import showEntrepreneurshipListConvocationFormAdmin from '@/pages/admin/entrepreneurships/show/showEntrepreneurshipListConvocationFormAdmin.vue'
import showEntrepreneurshipListTeamAdmin from '@/pages/admin/entrepreneurships/show/showEntrepreneurshipListTeamAdmin.vue'
import showEntrepreneurshipListWindowAdmin from '@/pages/admin/entrepreneurships/show/showEntrepreneurshipListWindowAdmin.vue'
import showEntrepreneurshipsListViewsAdmin from '@/pages/admin/entrepreneurships/show/showEntrepreneurshipsListViewsAdmin.vue'
import showEntrepreneurshipsListLikesAdmin from '@/pages/admin/entrepreneurships/show/showEntrepreneurshipsListLikesAdmin.vue'


import Indicators from '@/pages/admin/indicators/Indicators.vue'


import windowsAdmin from '@/pages/admin/windows/windowsAdmin.vue'
import showWindowAdmin from '@/pages/admin/windows/showWindowAdmin.vue'
import editWindowAdmin from '@/pages/admin/windows/editWindowAdmin.vue'

import EntrepreneursAdmin from '@/pages/admin/entrepreneurs/EntrepreneursAdmin.vue'

import ParticipantsAdmin from '@/pages/admin/participants/ParticipantsAdmin.vue'

import Evaluators from '@/pages/admin/evaluator/Evaluators.vue'
import ModuleAssigned from '@/pages/admin/evaluator/moduleAssigned.vue'

import Tutors from '@/pages/admin/tutor/tutors.vue'
import EntrepreneurshipsAssignedTutors from '@/pages/admin/tutor/moduleAssigned.vue'

import Users from '@/pages/admin/users/Users.vue'


import Config from '@/pages/admin/config/Config.vue'
import AcademicUnits from '@/pages/admin/config/AcademicUnits.vue'
import Careers from '@/pages/admin/config/Careers.vue'
import VerticalWorks from '@/pages/admin/config/VerticalWorks.vue'
import CommunicationChannel from '@/pages/admin/config/CommunicationChannel.vue'
import Positions from '@/pages/admin/config/Positions.vue'

import DevelopmentDegreeIP from '@/pages/admin/config/DevelopmentDegreeIP.vue'
import DevelopmentDegreeMDN from '@/pages/admin/config/DevelopmentDegreeMDN.vue'


import EntrepreneurshipNeed from '@/pages/admin/config/EntrepreneurshipNeed.vue'
import Countries from '@/pages/admin/config/Countries.vue'
import Provincias from '@/pages/admin/config/Provincias.vue'
import Localidades from '@/pages/admin/config/Localidades.vue'

const adminRoutes = [
  {
    path: '/admin/editions',
    name: 'editions',
    component: Editions,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        }
      ]
    }
  },
  {
    path: '/admin/editions/:edition_id',
    name: 'showEdition',
    component: showEdition,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Ver'
        }
      ]
    }
  },
  {
    path: '/admin/editions/:edition_id/edit',
    name: 'editEdition',
    component: editEdition,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar'
        }
      ]
    }
  },
  {
    path: '/admin/editions/:edition_id/edit/program-days',
    name: 'programEdition',
    component: programEdition,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar',
          to: { name: 'editEdition'}
        },
        {
          text: 'Programa'
        }
      ]
    }
  },
  {
    path: '/admin/editions/:edition_id/edit/program-days/new',
    name: 'newProgramEdition',
    component: newProgramEdition,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar',
          to: { name: 'editEdition'}
        },
        {
          text: 'Programa',
          to: { name: 'programEdition'}
        },
        {
          text: 'Nuevo'
        }
      ]
    }
  },
  {
    path: '/admin/editions/:edition_id/edit/program-days/:program_id/edit',
    name: 'editProgramEdition',
    component: editProgramEdition,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar',
          to: { name: 'editEdition'}
        },
        {
          text: 'Programa',
          to: { name: 'programEdition'}
        },
        {
          text: 'Editar'
        }
      ]
    }
  },
  {
    path: '/admin/editions/:edition_id/edit/program-days/:program_id/show',
    name: 'showProgramEdition',
    component: showProgramEdition,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar',
          to: { name: 'editEdition'}
        },
        {
          text: 'Programa',
          to: { name: 'programEdition'}
        },
        {
          text: 'Ver'
        }
      ]
    }
  },
  {
    path: '/admin/editions/:edition_id/edit/program-days/all',
    name: 'showAllProgramEdition',
    component: showAllProgramEdition,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar',
          to: { name: 'editEdition'}
        },
        {
          text: 'Programa',
          to: { name: 'programEdition'}
        },
        {
          text: 'Todo el programa'
        }
      ]
    }
  },
  {
    path: '/admin/editions/:edition_id/edit/program-days/:program_id/activities',
    name: 'activitiesProgramEdition',
    component: activitiesProgramEdition,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar',
          to: { name: 'editEdition'}
        },
        {
          text: 'Programa',
          to: { name: 'programEdition'}
        },
        {
          text: 'Actividades'
        }
      ]
    }
  },
  {
    path: '/admin/editions/:edition_id/edit/program-days/:program_id/activities/:activity_id/show',
    name: 'showActivityProgramEdition',
    component: showActivityProgramEdition,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar',
          to: { name: 'editEdition'}
        },
        {
          text: 'Programa',
          to: { name: 'programEdition'}
        },
        {
          text: 'Actividades',
          to: { name: 'activitiesProgramEdition'}
        },
        {
          text: 'Ver'
        }
      ]
    }
  },
  {
    path: '/admin/editions/:edition_id/edit/program-days/:program_id/activities/new',
    name: 'newActivityProgramEdition',
    component: newActivityProgramEdition,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar',
          to: { name: 'editEdition'}
        },
        {
          text: 'Programa',
          to: { name: 'programEdition'}
        },
        {
          text: 'Actividades',
          to: { name: 'activitiesProgramEdition'}
        },
        {
          text: 'Nuevo'
        }
      ]
    }
  },
  {
    path: '/admin/editions/:edition_id/edit/program-days/:program_id/activities/:activity_id/edit',
    name: 'editActivityProgramEdition',
    component: editActivityProgramEdition,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar',
          to: { name: 'editEdition'}
        },
        {
          text: 'Programa',
          to: { name: 'programEdition'}
        },
        {
          text: 'Actividades',
          to: { name: 'activitiesProgramEdition'}
        },
        {
          text: 'Editar'
        }
      ]
    }
  },
  {
    path: '/admin/editions/:edition_id/edit/program-days/:program_id/activities/all',
    name: 'showAllActivityProgramEdition',
    component: showAllActivityProgramEdition,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar',
          to: { name: 'editEdition'}
        },
        {
          text: 'Programa',
          to: { name: 'programEdition'}
        },
        {
          text: 'Actividades',
          to: { name: 'activitiesProgramEdition'}
        },
        {
          text: 'Ver Todos'
        }
      ]
    }
  },
  
  {
    path: '/admin/editions/:edition_id/edit/activities/:activity_id/show',
    name: 'showActivityEdition',
    component: showActivityEdition,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar',
          to: { name: 'editEdition'}
        },
        {
          text: 'Programa',
          to: { name: 'activitiesEdition'}
        },
        {
          text: 'Ver'
        }
      ]
    }
  },
  
  {
    path: '/admin/editions/:edition_id/edit/activities/all',
    name: 'showActivitiesEdition',
    component: showActivitiesEdition,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar',
          to: { name: 'editEdition'}
        },
        {
          text: 'Programa',
          to: { name: 'activitiesEdition'}
        },
        {
          text: 'Ver Todos'
        }
      ]
    }
  },
  
  {
    path: '/admin/editions/:edition_id/edit/name-edition',
    name: 'nameEdition',
    component: nameEdition,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar',
          to: { name: 'editEdition'}
        },
        {
          text: 'Nombre de la edición'
        }
      ]
    }
  },
  {
    path: '/admin/editions/:edition_id/edit/description-edition',
    name: 'descriptionEdition',
    component: descriptionEdition,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar',
          to: { name: 'editEdition'}
        },
        {
          text: 'Descripción de la edición'
        }
      ]
    }
  },
  
  {
    path: '/admin/editions/:edition_id/edit/auditoriums',
    name: 'auditoriumsEdition',
    component: auditoriumsEdition,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar',
          to: { name: 'editEdition'}
        },
        {
          text: 'Auditorios'
        }
      ]
    }
  },
  {
    path: '/admin/editions/:edition_id/edit/auditoriums/new',
    name: 'newAuditoriumEdition',
    component: newAuditoriumEdition,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar',
          to: { name: 'editEdition'}
        },
        {
          text: 'Auditorios',
          to: { name: 'auditoriumsEdition'}
        },
        {
          text: 'Nuevo'
        }
      ]
    }
  },
  
  {
    path: '/admin/editions/:edition_id/edit/auditoriums/:auditorium_id/edit',
    name: 'editAuditoriumEdition',
    component: editAuditoriumEdition,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar',
          to: { name: 'editEdition'}
        },
        {
          text: 'Auditorios',
          to: { name: 'auditoriumsEdition'}
        },
        {
          text: 'Editar'
        }
      ]
    }
  },
  {
    path: '/admin/editions/:edition_id/edit/auditoriums/:auditorium_id/show',
    name: 'showAuditoriumEdition',
    component: showAuditoriumEdition,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar',
          to: { name: 'editEdition'}
        },
        {
          text: 'Auditorios',
          to: { name: 'auditoriumsEdition'}
        },
        {
          text: 'Ver'
        }
      ]
    }
  },
  {
    path: '/admin/editions/:edition_id/edit/auditoriums/all',
    name: 'showAllAuditoriumEdition',
    component: showAllAuditoriumEdition,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar',
          to: { name: 'editEdition'}
        },
        {
          text: 'Auditorios',
          to: { name: 'auditoriumsEdition'}
        },
        {
          text: 'Ver Todos'
        }
      ]
    }
  },
  {
    path: '/admin/editions/:edition_id/edit/call-for-entrepreneurs',
    name: 'callForEntrepreneursEdition',
    component: callForEntrepreneursEdition,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar',
          to: { name: 'editEdition'}
        },
        {
          text: 'Convocatoria para Emprendedores'
        }
      ]
    }
  },
  {
    path: '/admin/editions/:edition_id/edit/general-public-income',
    name: 'generalPublicIncomeEdition',
    component: generalPublicIncomeEdition,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar',
          to: { name: 'editEdition'}
        },
        {
          text: 'Ingreso público general'
        }
      ]
    }
  },
  {
    path: '/admin/editions/:edition_id/edit/type-sponsors',
    name: 'typeSponsorsEdition',
    component: typeSponsorsEdition,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar',
          to: { name: 'editEdition'}
        },
        {
          text: 'Tipos de Sponsors'
        }
      ]
    }
  },
  {
    path: '/admin/editions/:edition_id/edit/type-sponsors/:types_sponsor_id/sponsors',
    name: 'sponsorsEdition',
    component: sponsorsEdition,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar',
          to: { name: 'editEdition'}
        },
        {
          text: 'Tipos de Sponsors',
          to: { name: 'typeSponsorsEdition' }
        },
        {
          text: 'Sponsors'
        }
      ]
    }
  },
  {
    path: '/admin/editions/:edition_id/edit/type-sponsors/:types_sponsor_id/sponsors/new',
    name: 'newSponsorEdition',
    component: newSponsorEdition,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar',
          to: { name: 'editEdition'}
        },
        {
          text: 'Tipos de Sponsors',
          to: { name: 'typeSponsorsEdition' }
        },
        {
          text: 'Sponsors',
          to: { name: 'sponsorsEdition'}
        },
        {
          text: 'Nuevo'
        }
      ]
    }
  },
  {
    path: '/admin/editions/:edition_id/edit/type-sponsors/:types_sponsor_id/sponsors/:sponsor_id/edit',
    name: 'editSponsorsEdition',
    component: editSponsorsEdition,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar',
          to: { name: 'editEdition'}
        },
        {
          text: 'Tipos de Sponsors',
          to: { name: 'typeSponsorsEdition' }
        },
        {
          text: 'Sponsors',
          to: { name: 'sponsorsEdition'}
        },
        {
          text: 'Editar'
        }
      ]
    }
  },
  {
    path: '/admin/editions/:edition_id/edit/type-sponsors/:types_sponsor_id/sponsors/:sponsor_id/show',
    name: 'showSponsorEdition',
    component: showSponsorEdition,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar',
          to: { name: 'editEdition'}
        },
        {
          text: 'Tipos de Sponsors',
          to: { name: 'typeSponsorsEdition' }
        },
        {
          text: 'Sponsors',
          to: { name: 'sponsorsEdition'}
        },
        {
          text: 'Ver'
        }
      ]
    }
  },
  {
    path: '/admin/editions/:edition_id/edit/type-sponsors/:types_sponsor_id/sponsors/all',
    name: 'showSponsorsEdition',
    component: showSponsorsEdition,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar',
          to: { name: 'editEdition'}
        },
        {
          text: 'Tipos de Sponsors',
          to: { name: 'typeSponsorsEdition' }
        },
        {
          text: 'Sponsors',
          to: { name: 'sponsorsEdition'}
        },
        {
          text: 'Todos los Sponsors'
        }
      ]
    }
  },
  {
    path: '/admin/editions/:edition_id/edit/type-sponsors/all-sponsors',
    name: 'showAllSponsorsEdition',
    component: showAllSponsorsEdition,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar',
          to: { name: 'editEdition'}
        },
        {
          text: 'Tipos de Sponsors',
          to: { name: 'typeSponsorsEdition' }
        },
        {
          text: 'Todos los Sponsors'
        }
      ]
    }
  },

  {
    path: '/admin/editions/:edition_id/edit/type-featured-sponsors',
    name: 'typeFeaturedSponsorsEdition',
    component: typeFeaturedSponsorsEdition,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar',
          to: { name: 'editEdition'}
        },
        {
          text: 'Tipos de Sponsors Destacados'
        }
      ]
    }
  },
  {
    path: '/admin/editions/:edition_id/edit/type-featured-sponsors/alls',
    name: 'showAllFeaturedSponsorsEdition',
    component: showAllFeaturedSponsorsEdition,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar',
          to: { name: 'editEdition'}
        },
        {
          text: 'Tipos de Sponsors Destacados',
          to: { name: 'typeFeaturedSponsorsEdition'}
        },
        {
          text: 'Sponsors Destacados'
        }
      ]
    }
  },
  

  {
    path: '/admin/editions/:edition_id/edit/type-featured-sponsors/:types_feature_sponsor_id/feature-sponsors',
    name: 'featuredSponsorsEdition',
    component: featuredSponsorsEdition,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar',
          to: { name: 'editEdition'}
        },
        {
          text: 'Tipos de Sponsors Destacados',
          to: { name: 'typeFeaturedSponsorsEdition' }
        },
        {
          text: 'Sponsors Destacados'
        }
      ]
    }
  },
  
  {
    path: '/admin/editions/:edition_id/edit/type-featured-sponsors/:types_feature_sponsor_id/feature-sponsors/new',
    name: 'newFeaturedSponsorEdition',
    component: newFeaturedSponsorEdition,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar',
          to: { name: 'editEdition'}
        },
        {
          text: 'Tipos de Sponsors Destacados',
          to: { name: 'typeFeaturedSponsorsEdition' }
        },
        {
          text: 'Sponsors Destacados',
          to: { name: 'featuredSponsorsEdition' }
        },
        {
          text: 'Nuevo'
        }
      ]
    }
  },
  
  {
    path: '/admin/editions/:edition_id/edit/type-featured-sponsors/:types_feature_sponsor_id/feature-sponsors/:feature_sponsor_id/show',
    name: 'showFeaturedSponsorEdition',
    component: showFeaturedSponsorEdition,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar',
          to: { name: 'editEdition'}
        },
        {
          text: 'Tipos de Sponsors Destacados',
          to: { name: 'typeFeaturedSponsorsEdition' }
        },
        {
          text: 'Sponsors Destacados',
          to: { name: 'featuredSponsorsEdition' }
        },
        {
          text: 'Ver'
        }
      ]
    }
  },
  {
    path: '/admin/editions/:edition_id/edit/type-featured-sponsors/:types_feature_sponsor_id/feature-sponsors/:feature_sponsor_id/edit',
    name: 'editFeaturedSponsorEdition',
    component: editFeaturedSponsorEdition,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar',
          to: { name: 'editEdition'}
        },
        {
          text: 'Tipos de Sponsors Destacados',
          to: { name: 'typeFeaturedSponsorsEdition' }
        },
        {
          text: 'Sponsors Destacados',
          to: { name: 'featuredSponsorsEdition' }
        },
        {
          text: 'Editar'
        }
      ]
    }
  },
  {
    path: '/admin/editions/:edition_id/edit/speakers',
    name: 'speakersEdition',
    component: speakersEdition,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar',
          to: { name: 'editEdition'}
        },
        {
          text: 'Speakers'
        }
      ]
    }
  },
  {
    path: '/admin/editions/:edition_id/edit/speakers/new',
    name: 'newSpeakerEdition',
    component: newSpeakerEdition,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar',
          to: { name: 'editEdition'}
        },
        {
          text: 'Speakers',
          to: { name: 'speakersEdition'}
        },
        {
          text: 'Nuevo'
        }
      ]
    }
  },
  {
    path: '/admin/editions/:edition_id/edit/speakers/:speaker_id/show',
    name: 'showSpeakerEdition',
    component: showSpeakerEdition,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar',
          to: { name: 'editEdition'}
        },
        {
          text: 'Speakers',
          to: { name: 'speakersEdition'}
        },
        {
          text: 'Ver'
        }
      ]
    }
  },
  {
    path: '/admin/editions/:edition_id/edit/speakers/:speaker_id/edit',
    name: 'editSpeakerEdition',
    component: editSpeakerEdition,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar',
          to: { name: 'editEdition'}
        },
        {
          text: 'Speakers',
          to: { name: 'speakersEdition'}
        },
        {
          text: 'Editar'
        }
      ]
    }
  },
  {
    path: '/admin/editions/:edition_id/edit/speakers/all',
    name: 'showSpeakersEdition',
    component: showSpeakersEdition,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar',
          to: { name: 'editEdition'}
        },
        {
          text: 'Speakers',
          to: { name: 'speakersEdition'}
        },
        {
          text: 'Ver todos'
        }
      ]
    }
  },
  //----------------------------------------------------------------
  {
    path: '/admin/editions/:edition_id/edit/evaluators',
    name: 'evaluatorsEdition',
    component: evaluatorsEdition,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar',
          to: { name: 'editEdition'}
        },
        {
          text: 'Evaluadores'
        }
      ]
    }
  },
  {
    path: '/admin/editions/:edition_id/edit/evaluators/new',
    name: 'newEvaluatorEdition',
    component: newEvaluatorEdition,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar',
          to: { name: 'editEdition'}
        },
        {
          text: 'Evaluadores',
          to: { name: 'evaluatorsEdition'}
        },
        {
          text: 'Nuevo'
        }
      ]
    }
  },
  {
    path: '/admin/editions/:edition_id/edit/evaluators/:evaluator_id/show',
    name: 'showEvaluatorEdition',
    component: showEvaluatorEdition,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar',
          to: { name: 'editEdition'}
        },
        {
          text: 'Evaluadores',
          to: { name: 'evaluatorsEdition'}
        },
        {
          text: 'Ver'
        }
      ]
    }
  },
  {
    path: '/admin/editions/:edition_id/edit/evaluators/:evaluator_id/edit',
    name: 'editEvaluatorEdition',
    component: editEvaluatorEdition,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar',
          to: { name: 'editEdition'}
        },
        {
          text: 'Evaluadores',
          to: { name: 'evaluatorsEdition'}
        },
        {
          text: 'Editar'
        }
      ]
    }
  },
  {
    path: '/admin/editions/:edition_id/edit/evaluators/all',
    name: 'showEvaluatorsEdition',
    component: showEvaluatorsEdition,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar',
          to: { name: 'editEdition'}
        },
        {
          text: 'Evaluadores',
          to: { name: 'evaluatorsEdition'}
        },
        {
          text: 'Ver todos'
        }
      ]
    }
  },
  //----------------------------------------------------------------
  {
    path: '/admin/editions/:edition_id/edition-organizers',
    name: 'editionOrganizers',
    component: editionOrganizers,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar',
          to: { name: 'editEdition'}
        },
        {
          text: 'Organizadores de la edición'
        }
      ]
    }
  },
  {
    path: '/admin/editions/:edition_id/edition-organizers/all',
    name: 'showEditionOrganizers',
    component: showEditionOrganizers,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar',
          to: { name: 'editEdition'}
        },        
        {
          text: 'Organizadores de la edición',
          to: { name: 'editionOrganizers'}
        },
        {
          text: 'Todos'
        },

      ]
    }
  },
  //----------------------------------------------------------------
  {
    path: '/admin/editions/:edition_id/edit/juries',
    name: 'juriesEdition',
    component: juriesEdition,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar',
          to: { name: 'editEdition'}
        },
        {
          text: 'Jurados'
        }
      ]
    }
  },
  {
    path: '/admin/editions/:edition_id/edit/juries/new',
    name: 'newJuryEdition',
    component: newJuryEdition,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar',
          to: { name: 'editEdition'}
        },
        {
          text: 'Jurados',
          to: { name: 'juriesEdition'}
        },
        {
          text: 'Nuevo'
        }
      ]
    }
  },
  {
    path: '/admin/editions/:edition_id/edit/juries/:jury_id/show',
    name: 'showJuryEdition',
    component: showJuryEdition,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar',
          to: { name: 'editEdition'}
        },
        {
          text: 'Jurados',
          to: { name: 'juriesEdition'}
        },
        {
          text: 'Ver'
        }
      ]
    }
  },
  {
    path: '/admin/editions/:edition_id/edit/juries/:jury_id/edit',
    name: 'editJuryEdition',
    component: editJuryEdition,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar',
          to: { name: 'editEdition'}
        },
        {
          text: 'Jurados',
          to: { name: 'juriesEdition'}
        },
        {
          text: 'Editar'
        }
      ]
    }
  },
  {
    path: '/admin/editions/:edition_id/edit/juries/all',
    name: 'showJuriesEdition',
    component: showJuriesEdition,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar',
          to: { name: 'editEdition'}
        },
        {
          text: 'Jurados',
          to: { name: 'juriesEdition'}
        },
        {
          text: 'Ver'
        }
      ]
    }
  },
  // {
  //   path: '/admin/editions/:edition_id/edit/juries/:jury_id/show',
  //   name: 'newJuryEdition',
  //   component: newJuryEdition,
  //   meta: {
  //     auth: true,
  //     role: 'admin', 
  //     breadCrumb: [
  //       {
  //         text: 'Admin',
  //         to: { name: 'home' }
  //       },
  //       {
  //         text: 'Ediciones',
  //         to: { name: 'editions' }
  //       },
  //       {
  //         text: 'Editar',
  //         to: { name: 'editEdition'}
  //       },
  //       {
  //         text: 'Jurados',
  //         to: { name: 'juriesEdition'}
  //       },
  //       {
  //         text: 'Nuevo'
  //       }
  //     ]
  //   }
  // },
  {
    path: '/admin/editions/:edition_id/edit/terms-conditions',
    name: 'termsConditionsEdition',
    component: termsConditionsEdition,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar',
          to: { name: 'editEdition'}
        },
        {
          text: 'Terminos y condiciones'
        }
      ]
    }
  },
  {
    path: '/admin/editions/:edition_id/edit/about-jije',
    name: 'aboutJIJEEdition',
    component: aboutJIJEEdition,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar',
          to: { name: 'editEdition'}
        },
        {
          text: 'Acerca de JIJE'
        }
      ]
    }
  },
  {
    path: '/admin/editions/:edition_id/edit/enable-edit-stand',
    name: 'enableEditStandEdition',
    component: enableEditStandEdition,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar',
          to: { name: 'editEdition'}
        },
        {
          text: 'Habilitación de edicion de stands'
        }
      ]
    }
  },
  {
    path: '/admin/editions/:edition_id/edit/customization',
    name: 'customizationEdition',
    component: customizationEdition,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar',
          to: { name: 'editEdition'}
        },
        {
          text: 'Personalización'
        }
      ]
    }
  },
  {
    path: '/admin/editions/:edition_id/edit/customization/home',
    name: 'customizationHome',
    component: customizationHome,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar',
          to: { name: 'editEdition'}
        },
        {
          text: 'Personalización',
          to: { name: 'customizationEdition'}
        },
        {
          text: 'Home'
        }
      ]
    }
  },
  {
    path: '/admin/editions/:edition_id/edit/customization/app-bar',
    name: 'customizationAppBar',
    component: customizationAppBar,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar',
          to: { name: 'editEdition'}
        },
        {
          text: 'Personalización',
          to: { name: 'customizationEdition'}
        },
        {
          text: 'Menú lateral'
        }
      ]
    }
  },
  {
    path: '/admin/editions/:edition_id/edit/customization/juries-evaluators',
    name: 'customizationJuriesCard',
    component: customizationJuriesCard,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar',
          to: { name: 'editEdition'}
        },
        {
          text: 'Personalización',
          to: { name: 'customizationEdition'}
        },
        {
          text: 'Tarjetas Jurados y Evaluadores'
        }
      ]
    }
  },
  {
    path: '/admin/editions/:edition_id/edit/customization/speaker-card',
    name: 'customizationSpeakerCard',
    component: customizationSpeakerCard,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar',
          to: { name: 'editEdition'}
        },
        {
          text: 'Personalización',
          to: { name: 'customizationEdition'}
        },
        {
          text: 'Tarjeta Skeaker'
        }
      ]
    }
  },
  {
    path: '/admin/editions/:edition_id/edit/customization/assistants-entrepreneurs-card',
    name: 'customizationEntreprenursAssistentsCard',
    component: customizationEntreprenursAssistentsCard,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar',
          to: { name: 'editEdition'}
        },
        {
          text: 'Personalización',
          to: { name: 'customizationEdition'}
        },
        {
          text: 'Tarjeta Skeaker'
        }
      ]
    }
  },
  {
    path: '/admin/editions/:edition_id/edit/customization/project-gallery',
    name: 'customizationProjectGallery',
    component: customizationProjectGallery,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar',
          to: { name: 'editEdition'}
        },
        {
          text: 'Personalización',
          to: { name: 'customizationEdition'}
        },
        {
          text: 'Galeria de Emprendimientos'
        }
      ]
    }
  },
  {
    path: '/admin/editions/:edition_id/edit/customization/my-project',
    name: 'customizationMyProject',
    component: customizationMyProject,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar',
          to: { name: 'editEdition'}
        },
        {
          text: 'Personalización',
          to: { name: 'customizationEdition'}
        },
        {
          text: 'Mi Proyecto (solo emprendedores)'
        }
      ]
    }
  },
  {
    path: '/admin/editions/:edition_id/edit/customization/auditoriums',
    name: 'customizationAuditorium',
    component: customizationAuditorium,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar',
          to: { name: 'editEdition'}
        },
        {
          text: 'Personalización',
          to: { name: 'customizationEdition'}
        },
        {
          text: 'Auditorios'
        }
      ]
    }
  },
  {
    path: '/admin/editions/:edition_id/edit/customization/program',
    name: 'customizationProgram',
    component: customizationProgram,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar',
          to: { name: 'editEdition'}
        },
        {
          text: 'Personalización',
          to: { name: 'customizationEdition'}
        },
        {
          text: 'Programa'
        }
      ]
    }
  },
  {
    path: '/admin/editions/:edition_id/edit/customization/about',
    name: 'customizationAbout',
    component: customizationAbout,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar',
          to: { name: 'editEdition'}
        },
        {
          text: 'Personalización',
          to: { name: 'customizationEdition'}
        },
        {
          text: 'Acerca de JIJE'
        }
      ]
    }
  },
  {
    path: '/admin/editions/:edition_id/edit/customization/waiting-room',
    name: 'customizationWaitingRoom',
    component: customizationWaitingRoom,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar',
          to: { name: 'editEdition'}
        },
        {
          text: 'Personalización',
          to: { name: 'customizationEdition'}
        },
        {
          text: 'Sala de espera'
        }
      ]
    }
  },
  
  {
    path: '/admin/editions/:edition_id/entrepreneurships',
    name: 'entrepreneurshipsEdition',
    component: entrepreneurshipsEdition,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Emprendimientos'
        }
      ]
    }
  },
  {
    path: '/admin/editions/:edition_id/entrepreneurships/new',
    name: 'newEntrepreneurshipEdition',
    component: newEntrepreneurshipEdition,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Emprendimientos',
          to: { name: 'entrepreneurshipsEdition'}
        },
        {
          text: 'Nuevo'
        }
      ]
    }
  },
  {
    path: '/admin/editions/:edition_id/convocation-form/:convocation_form_id',
    name: 'showConvocationFormEdition',
    component: showConvocationFormEdition,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Emprendimientos',
          to: { name: 'entrepreneurshipsEdition' }
        },
        {
          text: 'Ver'
        }
      ]
    }
  },
  {
    path: '/admin/editions/:edition_id/entrepreneurships/:entrepreneurship_id',
    name: 'showEntrepreneurshipsEdition',
    component: showEntrepreneurshipsEdition,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Emprendimientos',
          to: { name: 'entrepreneurshipsEdition' }
        },
        {
          text: 'Ver'
        }
      ]
    }
  },
  {
    path: '/admin/landing',
    name: 'customizationLanding',
    component: customizationLanding,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Landing Page'
        }
      ]
    }
  },
  {
    path: '/admin/landing/main-section',
    name: 'customizationMainSection',
    component: customizationMainSection,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Landing Page',
          to: { name: 'customizationLanding' }
        },
        {
          text: 'Sección Principal'
        }
      ]
    }
  },
  {
    path: '/admin/landing/featured-sponsors-section',
    name: 'customizationFeaturedSponsorsSection',
    component: customizationFeaturedSponsorsSection,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Landing Page',
          to: { name: 'customizationLanding' }
        },
        {
          text: 'Patrocinadores Destacados'
        }
      ]
    }
  },
  {
    path: '/admin/landing/auth-section',
    name: 'customizationAuthSection',
    component: customizationAuthSection,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Landing Page',
          to: { name: 'customizationLanding' }
        },
        {
          text: 'Registro Asistentes/Login'
        }
      ]
    }
  },
  {
    path: '/admin/landing/text-section',
    name: 'customizationTextSection',
    component: customizationTextSection,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Landing Page',
          to: { name: 'customizationLanding' }
        },
        {
          text: 'Texto Landing'
        }
      ]
    }
  },
  {
    path: '/admin/landing/indicators-section',
    name: 'customizationIndicatorsSection',
    component: customizationIndicatorsSection,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Landing Page',
          to: { name: 'customizationLanding' }
        },
        {
          text: 'Indicadores'
        }
      ]
    }
  },
  {
    path: '/admin/landing/featured-entrepreneurships-section',
    name: 'customizationFeaturedEntrepreneurshipsSection',
    component: customizationFeaturedEntrepreneurshipsSection,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Landing Page',
          to: { name: 'customizationLanding' }
        },
        {
          text: 'Emprendimientos Destacados'
        }
      ]
    }
  },
  {
    path: '/admin/landing/contact-section',
    name: 'customizationContactSection',
    component: customizationContactSection,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Landing Page',
          to: { name: 'customizationLanding' }
        },
        {
          text: 'Contacto'
        }
      ]
    }
  },
  
  {
    path: '/admin/editions/:edition_id/entrepreneurships/:entrepreneurship_id/convocation-form',
    name: 'showConvocationFormAccepted',
    component: showConvocationFormAccepted,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Emprendimientos',
          to: { name: 'entrepreneurshipsEdition' }
        },
        {
          text: 'Ver',
          to: { name: 'showEntrepreneurshipsEdition' }
        },
        {
          text: 'Formularaio de convocatoria'
        }
      ]
    }
  },
  {
    path: '/admin/editions/:edition_id/entrepreneurships/:entrepreneurship_id/team',
    name: 'showTeamAccepted',
    component: showTeamAccepted,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Emprendimientos',
          to: { name: 'entrepreneurshipsEdition' }
        },
        {
          text: 'Ver',
          to: { name: 'showEntrepreneurshipsEdition' }
        },
        {
          text: 'Equipo emprendedor'
        }
      ]
    }
  },
  {
    path: '/admin/editions/:edition_id/entrepreneurships/:entrepreneurship_id/show-window',
    name: 'showWindowAccepted',
    component: showWindowAccepted,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Emprendimientos',
          to: { name: 'entrepreneurshipsEdition' }
        },
        {
          text: 'Ver',
          to: { name: 'showEntrepreneurshipsEdition' }
        },
        {
          text: 'Stand'
        }
      ]
    }
  },
  {
    path: '/admin/editions/:edition_id/entrepreneurships/:entrepreneurship_id/show-modules-pre-incubation',
    name: 'showModulesPreIncubations',
    component: showModulesPreIncubations,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Emprendimientos',
          to: { name: 'entrepreneurshipsEdition' }
        },
        {
          text: 'Ver',
          to: { name: 'showEntrepreneurshipsEdition' }
        },
        {
          text: 'Modulos pre-incubación'
        }
      ]
    }
  },
  {
    path: '/admin/editions/:edition_id/entrepreneurships/:entrepreneurship_id/show-modules-pre-incubation/:module_pre_incubation_id',
    name: 'showModulePreIncubation',
    component: showModulePreIncubation,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Emprendimientos',
          to: { name: 'entrepreneurshipsEdition' }
        },
        {
          text: 'Ver',
          to: { name: 'showEntrepreneurshipsEdition' }
        },
        {
          text: 'Modulos pre-incubación',
          to: { name: 'showModulesPreIncubations' }
        },
        {
          text: 'Ver'
        }
      ]
    }
  },
  {
    path: '/admin/editions/:edition_id/edit/resources-for-entrepreneurs',
    name: 'modules',
    component: modules,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar',
          to: { name: 'editEdition' }
        },
        {
          text: 'Recursos para emprendedores'
        }
      ]
    }
  },
  {
    path: '/admin/editions/:edition_id/edit/resources-for-entrepreneurs/:module_id/show',
    name: 'showModule',
    component: showModule,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar',
          to: { name: 'editEdition' }
        },
        {
          text: 'Recursos para emprendedores',
          to: { name: 'modules' }
        },
        {
          text: 'Ver',
        }
      ]
    }
  },
  {
    path: '/admin/editions/:edition_id/edit/resources-for-entrepreneurs/all/module',
    name: 'showAllModule',
    component: showAllModule,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar',
          to: { name: 'editEdition' }
        },
        {
          text: 'Recursos para emprendedores',
          to: { name: 'modules' }
        },
        {
          text: 'Módulos',
        }
      ]
    }
  },
  {
    path: '/admin/editions/:edition_id/edit/resources-for-entrepreneurs/all/module/:slug/pill',
    name: 'showPillModule',
    component: showPillModule,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar',
          to: { name: 'editEdition' }
        },
        {
          text: 'Recursos para emprendedores',
          to: { name: 'modules' }
        },
        {
          text: 'Módulos',
          to: { name: 'showAllModule' }
        },
        {
          text: 'Vér',
        }
      ]
    }
  },
  {
    path: '/admin/editions/:edition_id/edit/resources-for-entrepreneurs/new-module',
    name: 'newModule',
    component: newModule,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar',
          to: { name: 'editEdition' }
        },
        {
          text: 'Recursos para emprendedores',
          to: { name: 'modules' }
        },
        {
          text: 'Nuevo',
        }
      ]
    }
  },
  {
    path: '/admin/editions/:edition_id/edit/resources-for-entrepreneurs/:module_id/edit',
    name: 'editModule',
    component: editModule,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar',
          to: { name: 'editEdition' }
        },
        {
          text: 'Recursos para emprendedores',
          to: { name: 'modules' }
        },
        {
          text: 'Editar',
        }
      ]
    }
  },
  {
    path: '/admin/editions/:edition_id/edit/resources-for-entrepreneurs/:module_id/pills',
    name: 'pillsModule',
    component: pillsModule,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar',
          to: { name: 'editEdition' }
        },
        {
          text: 'Recursos para emprendedores',
          to: { name: 'modules' }
        },
        {
          text: 'Pildoras',
        }
      ]
    }
  },
  {
    path: '/admin/editions/:edition_id/edit/resources-for-entrepreneurs/:module_id/pills/new',
    name: 'newPill',
    component: newPill,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar',
          to: { name: 'editEdition' }
        },
        {
          text: 'Recursos para emprendedores',
          to: { name: 'modules' }
        },
        {
          text: 'Pildoras',
          to: { name: 'pills' }
        },
        {
          text: 'Nueva',
         }
      ]
    }
  },
  {
    path: '/admin/editions/:edition_id/edit/resources-for-entrepreneurs/:module_id/pills/show/:pill_id',
    name: 'showPill',
    component: showPill,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar',
          to: { name: 'editEdition' }
        },
        {
          text: 'Recursos para emprendedores',
          to: { name: 'modules' }
        },
        {
          text: 'Pildoras',
          to: { name: 'pills' }
        },
        {
          text: 'Ver',
         }
      ]
    }
  },
  {
    path: '/admin/editions/:edition_id/edit/resources-for-entrepreneurs/:module_id/pills/edit/:pill_id',
    name: 'editPill',
    component: editPill,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Ediciones',
          to: { name: 'editions' }
        },
        {
          text: 'Editar',
          to: { name: 'editEdition' }
        },
        {
          text: 'Recursos para emprendedores',
          to: { name: 'modules' }
        },
        {
          text: 'Pildoras',
          to: { name: 'pills' }
        },
        {
          text: 'Editar',
         }
      ]
    }
  },
  {
    path: '/admin/entrepreneurships',
    name: 'EntrepreneurshipsList',
    component: EntrepreneurshipsList,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Emprendimientos'
        }
      ]
    }
  },
  {
    path: '/admin/entrepreneurships/:entrepreneurship_id',
    name: 'showEntrepreneurshipListAdmin',
    component: showEntrepreneurshipListAdmin,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Emprendimientos',
          to: { name: 'EntrepreneurshipsList' }
        },
        {
          text: 'Ver'
        }
      ]
    }
  },
  {
    path: '/admin/entrepreneurships/:entrepreneurship_id/convocation-form',
    name: 'showEntrepreneurshipListConvocationFormAdmin',
    component: showEntrepreneurshipListConvocationFormAdmin,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Emprendimientos',
          to: { name: 'EntrepreneurshipsList' }
        },{
          text: 'Ver',
          to: { name: 'showEntrepreneurshipListAdmin' }
        },
        {
          text: 'Formulario de la convocatoria'
        }
      ]
    }
  },
  {
    path: '/admin/entrepreneurships/:entrepreneurship_id/team',
    name: 'showEntrepreneurshipListTeamAdmin',
    component: showEntrepreneurshipListTeamAdmin,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Emprendimientos',
          to: { name: 'EntrepreneurshipsList' }
        },{
          text: 'Ver',
          to: { name: 'showEntrepreneurshipListAdmin' }
        },
        {
          text: 'Integrantes'
        }
      ]
    }
  },
  {
    path: '/admin/entrepreneurships/:entrepreneurship_id/show-window',
    name: 'showEntrepreneurshipListWindowAdmin',
    component: showEntrepreneurshipListWindowAdmin,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Emprendimientos',
          to: { name: 'EntrepreneurshipsList' }
        },{
          text: 'Ver',
          to: { name: 'showEntrepreneurshipListAdmin' }
        },
        {
          text: 'Stand'
        }
      ]
    }
  },
  {
    path: '/admin/entrepreneurships/:entrepreneurship_id/views',
    name: 'showEntrepreneurshipsListViewsAdmin',
    component: showEntrepreneurshipsListViewsAdmin,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Emprendimientos',
          to: { name: 'EntrepreneurshipsList' }
        },{
          text: 'Ver',
          to: { name: 'showEntrepreneurshipListAdmin' }
        },
        {
          text: 'Visualizaciones'
        }
      ]
    }
  },
  {
    path: '/admin/entrepreneurships/:entrepreneurship_id/likes',
    name: 'showEntrepreneurshipsListLikesAdmin',
    component: showEntrepreneurshipsListLikesAdmin,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Emprendimientos',
          to: { name: 'EntrepreneurshipsList' }
        },{
          text: 'Ver',
          to: { name: 'showEntrepreneurshipListAdmin' }
        },
        {
          text: 'Likes'
        }
      ]
    }
  },

  
  {
    path: '/admin/indicators',
    name: 'Indicators',
    component: Indicators,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Indicadores'
        }
      ]
    }
  },
  
  {
    path: '/admin/project-gallery',
    name: 'windowsAdmin',
    component: windowsAdmin,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Galeria de Emprendimientos'
        }
      ]
    }
  },
  {
    path: '/admin/project-gallery/:entrepreneurship_id',
    name: 'showWindowAdmin',
    component: showWindowAdmin,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Galeria de Emprendimientos',
          to: { name: 'windowsAdmin' }
        },
        {
          text: 'Stand'
        }
      ]
    }
  },
  {
    path: '/admin/project-gallery/:entrepreneurship_id/edit',
    name: 'editWindowAdmin',
    component: editWindowAdmin,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Galeria de Emprendimientos',
          to: { name: 'windowsAdmin' }
        },{
          text: 'Stand',
          to: { name: 'showWindowAdmin' }
        },
        {
          text: 'Editar'
        }
      ]
    }
  },
  {
    path: '/admin/entrepreneurs',
    name: 'entrepreneurs',
    component: EntrepreneursAdmin,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Emprendedores'
        }
      ]
    }
  },
  {
    path: '/admin/general-public',
    name: 'ParticipantsAdmin',
    component: ParticipantsAdmin,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Público General'
        }
      ]
    }
  },
  
  {
    path: '/admin/evaluators',
    name: 'evaluators',
    component: Evaluators,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Evaluadores',
        }
      ]
    }
  },
  {
    path: '/admin/evaluators/module-assigned/:evaluator_id',
    name: 'moduleAssigned',
    component: ModuleAssigned,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Evaluadores',
          to: { name: 'evaluators' }
        },
        {
          text: 'Proyectos asignados'
        }
      ]
    }
  },
  {
    path: '/admin/tutors',
    name: 'tutors',
    component: Tutors,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Tutores',
        }
      ]
    }
  },
  {
    path: '/admin/tutors/module-assigned/:tutor_id',
    name: 'entrepreneurshipsAssignedTutors',
    component: EntrepreneurshipsAssignedTutors,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Tutores',
          to: { name: 'tutors' }
        },
        {
          text: 'Proyectos asignados'
        }
      ]
    }
  },
  {
    path: '/admin/users',
    name: 'users',
    component: Users,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Usuarios',
        }
      ]
    }
  },
  {
    path: '/admin/config',
    name: 'config',
    component: Config,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Configuración'
        }
      ]
    }
  },
  {
    path: '/admin/config/academic-units',
    name: 'academicUnits',
    component: AcademicUnits,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Configuración',
          to: { name: 'config'}
        },
        {
          text: 'Unidades Académicas'
        }
      ]
    }
  },
  {
    path: '/admin/config/careers',
    name: 'careers',
    component: Careers,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Configuración',
          to: { name: 'config'}
        },
        {
          text: 'Carreras'
        }
      ]
    }
  },
  {
    path: '/admin/config/vertical-works',
    name: 'verticalWorks',
    component: VerticalWorks,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Configuración',
          to: { name: 'config'}
        },
        {
          text: 'Verticales de Trabajo'
        }
      ]
    }
  },
  {
    path: '/admin/config/comunication-channels',
    name: 'CommunicationChannel',
    component: CommunicationChannel,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Configuración',
          to: { name: 'config'}
        },
        {
          text: 'Canales de Comunicación'
        }
      ]
    }
  },
  {
    path: '/admin/config/positions',
    name: 'Positions',
    component: Positions,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Configuración',
          to: { name: 'config'}
        },
        {
          text: 'Posiciones/roles emprendimiento'
        }
      ]
    }
  },
  {
    path: '/admin/config/development-degree-ip',
    name: 'DevelopmentDegreeIP',
    component: DevelopmentDegreeIP,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Configuración',
          to: { name: 'config'}
        },
        {
          text: 'Grado de desarrollo IP'
        }
      ]
    }
  },
  
  {
    path: '/admin/config/development-degree-mdn',
    name: 'DevelopmentDegreeMDN',
    component: DevelopmentDegreeMDN,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Configuración',
          to: { name: 'config'}
        },
        {
          text: 'Grado de desarrollo MDN'
        }
      ]
    }
  },
  {
    path: '/admin/config/entrepreneurship-needs',
    name: 'entrepreneurshipNeed',
    component: EntrepreneurshipNeed,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Configuración',
          to: { name: 'config'}
        },
        {
          text: 'Necesidades de los Emprendimientos'
        }
      ]
    }
  },
  {
    path: '/admin/config/countries',
    name: 'countries',
    component: Countries,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Configuración',
          to: { name: 'config'}
        },
        {
          text: 'Paises'
        }
      ]
    }
  },
  {
    path: '/admin/config/provincias',
    name: 'provincias',
    component: Provincias,
    meta: {
      auth: true,
      role: 'admin', 
      breadCrumb: [
        {
          text: 'Configuración',
          to: { name: 'config'}
        },
        {
          text: 'Provincias'
        }
      ]
    }
  },
  {
    path: '/admin/config/localidades',
    name: 'localidades',
    component: Localidades,
    meta: {
      auth: true,
      role: 'admin',
      breadCrumb: [
        {
          text: 'Configuración',
          to: { name: 'config'}
        },
        {
          text: 'Localidades'
        }
      ]
    }
  },

]

export default adminRoutes